<h1 class="iag-heading m-heading" [ngClass]="extraClasses">
  {{ titleText | translate }}
</h1>
<h2 class="iag-subheading m-subheading" [ngClass]="subExtraClasses" *ngIf="subtitleText">
  {{ subtitleText | translate }}
</h2>
